import type { FilterOption } from '@frontend/libs/types/shop'

import { ChevronDownIcon } from '@heroicons/react/24/outline'
import {
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { useState } from 'react'

export interface DropdownFilterProps {
  label?: string
  onChange?: (value: string[]) => void
  onSubmit?: () => void
  options?: FilterOption[]
  value?: string[]
}

export function DropdownFilter({
  label,
  onChange,
  onSubmit,
  options,
  value,
}: Readonly<DropdownFilterProps>) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnSubmit() {
    if (onSubmit) {
      onSubmit()
    }

    setIsOpen(false)
  }

  return (
    <Popover
      classNames={{
        content:
          'w-full justify-center subpixel-antialiased flex min-w-[220px] max-w-md flex-col items-start p-4',
      }}
      isOpen={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
      placement="bottom"
    >
      <PopoverTrigger>
        <Button variant="light">
          {label}{' '}
          {value && value.length > 0 && (
            <span className="inline-block bg-primary px-2 py-1 text-xs leading-none text-white">
              {value.length}
            </span>
          )}
          <ChevronDownIcon className="h-5 w-5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <span className="mb-2 block font-medium uppercase">{label}</span>
        <div className="max-h-80 w-full overflow-y-auto overflow-x-hidden px-1 py-2">
          <CheckboxGroup onChange={onChange} value={value}>
            {options?.map((option) => (
              <Checkbox key={option.id} value={option.slug}>
                {option.name}
              </Checkbox>
            ))}
          </CheckboxGroup>
        </div>
        <hr className="mt-3 h-divider w-full shrink-0 border-none bg-default-100" />
        <div className="mt-3 flex w-full justify-end gap-2">
          <ButtonGroup className="gap-1">
            <Button
              onPress={() => setIsOpen((prev) => !prev)}
              size="sm"
              variant="bordered"
            >
              {__('Cancel', 'asavagroup')}
            </Button>
            <Button
              color="primary"
              onPress={handleOnSubmit}
              size="sm"
              variant="solid"
            >
              {__('Apply', 'asavagroup')}
            </Button>
          </ButtonGroup>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default DropdownFilter
